import FilesDocumentationTree from './FilesDocumentationTree'

export default FilesDocumentationTree
